import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/data/company";
import { Button } from "@/components/ui/button";

const H = ({ children }) => (
  <h2 className="font-display text-2xl font-bold text-slate-900 mt-10 mb-3">{children}</h2>
);

const openSettings = () => {
  window.dispatchEvent(new CustomEvent("c2-open-cookie-settings"));
};

const CookiePolicy = () => {
  return (
    <LegalLayout title="Politica de cookies" lastUpdated={COMPANY.legalLastUpdated}>
      <p className="text-slate-700">
        Site-ul <strong>{COMPANY.website}</strong>, operat de{" "}
        <strong>{COMPANY.legalName}</strong> (CUI: {COMPANY.cui}), utilizează
        cookies pentru a-ți oferi o experiență optimă și pentru a măsura performanța
        site-ului. Această pagină îți explică ce sunt cookies, de ce le folosim și
        cum poți să le controlezi.
      </p>

      <H>1. Ce sunt cookies?</H>
      <p>
        Cookies sunt fișiere text mici stocate pe dispozitivul tău (telefon, tabletă,
        laptop) atunci când vizitezi un site web. Ele permit site-ului să recunoască
        dispozitivul și să-ți rețină anumite informații despre vizita ta.
      </p>

      <H>2. Tipuri de cookies pe care le folosim</H>

      <h3 className="font-display text-lg font-semibold text-slate-900 mt-6 mb-2">
        2.1 Cookies strict necesare
      </h3>
      <p>
        Permit funcționarea de bază a site-ului (ex: trimiterea formularului de
        contact, securitate, balansare de încărcare). <strong>Nu pot fi
        dezactivate</strong> deoarece site-ul nu ar funcționa corect fără ele. Nu
        stochează date personale identificabile.
      </p>

      <h3 className="font-display text-lg font-semibold text-slate-900 mt-6 mb-2">
        2.2 Cookies de analiză (opționale)
      </h3>
      <p>
        Ne ajută să înțelegem cum este folosit site-ul (pagini vizitate, durata
        vizitei, sursa traficului), pentru a-l îmbunătăți. Folosim Google
        Analytics 4, cu IP anonimizat. Aceste cookies se activează doar după ce
        accepți.
      </p>

      <h3 className="font-display text-lg font-semibold text-slate-900 mt-6 mb-2">
        2.3 Cookies de marketing (opționale)
      </h3>
      <p>
        Permit măsurarea performanței campaniilor publicitare și afișarea de
        anunțuri relevante (ex: Meta Pixel pentru Facebook/Instagram, Google Ads).
        Se activează doar după ce accepți.
      </p>

      <H>3. Cookies third-party folosite</H>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-slate-200 rounded-lg overflow-hidden">
          <thead className="bg-slate-50 text-slate-700">
            <tr>
              <th className="text-left p-3 font-semibold">Cookie</th>
              <th className="text-left p-3 font-semibold">Furnizor</th>
              <th className="text-left p-3 font-semibold">Scop</th>
              <th className="text-left p-3 font-semibold">Durată</th>
            </tr>
          </thead>
          <tbody className="text-slate-700">
            <tr className="border-t border-slate-200">
              <td className="p-3 font-mono text-xs">_ga, _ga_*</td>
              <td className="p-3">Google Analytics</td>
              <td className="p-3">Analiză trafic anonimă</td>
              <td className="p-3">până la 24 luni</td>
            </tr>
            <tr className="border-t border-slate-200 bg-slate-50/40">
              <td className="p-3 font-mono text-xs">_fbp</td>
              <td className="p-3">Meta (Facebook)</td>
              <td className="p-3">Marketing & remarketing</td>
              <td className="p-3">90 zile</td>
            </tr>
            <tr className="border-t border-slate-200">
              <td className="p-3 font-mono text-xs">c2_cookie_consent_v1</td>
              <td className="p-3">c2advertising.ro</td>
              <td className="p-3">Reține preferințele tale de cookies</td>
              <td className="p-3">12 luni</td>
            </tr>
          </tbody>
        </table>
      </div>

      <H>4. Cum poți gestiona cookies</H>
      <p>
        Poți schimba preferințele oricând apăsând butonul de mai jos sau folosind
        link-ul „Setări cookies" din subsolul site-ului. De asemenea, poți șterge
        cookies din setările browser-ului tău.
      </p>
      <Button
        onClick={openSettings}
        data-testid="cookie-policy-reopen"
        className="mt-3 rounded-full bg-magenta hover:bg-[#C2185B] text-white"
      >
        Deschide setări cookies
      </Button>

      <H>5. Setări browser</H>
      <p>
        Majoritatea browser-elor permit blocarea sau ștergerea cookies. Iată
        ghiduri oficiale:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <a
            href="https://support.google.com/chrome/answer/95647"
            target="_blank"
            rel="noopener noreferrer"
            className="text-magenta hover:underline"
          >
            Google Chrome
          </a>
        </li>
        <li>
          <a
            href="https://support.mozilla.org/ro/kb/cookie-uri-informatii-stocate-de-site-uri-pe-c"
            target="_blank"
            rel="noopener noreferrer"
            className="text-magenta hover:underline"
          >
            Mozilla Firefox
          </a>
        </li>
        <li>
          <a
            href="https://support.apple.com/ro-ro/guide/safari/sfri11471/mac"
            target="_blank"
            rel="noopener noreferrer"
            className="text-magenta hover:underline"
          >
            Safari
          </a>
        </li>
        <li>
          <a
            href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
            target="_blank"
            rel="noopener noreferrer"
            className="text-magenta hover:underline"
          >
            Microsoft Edge
          </a>
        </li>
      </ul>

      <H>6. Contact</H>
      <p>
        Pentru întrebări legate de această politică, scrie-ne la{" "}
        <a
          href={`mailto:${COMPANY.dpoEmail}`}
          className="text-magenta hover:underline font-semibold"
        >
          {COMPANY.dpoEmail}
        </a>
        .
      </p>
    </LegalLayout>
  );
};

export default CookiePolicy;
